<template>
    <EpicorPartInventory></EpicorPartInventory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EpicorPartInventory = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/PartInventory/Table.vue")
);

export default {
    name: "Project_EpicorPartInventory",
    components: { EpicorPartInventory, AuthLayout },
};
</script>
